/* eslint-disable camelcase */
import React from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'

import { useAddNotificationMutation } from 'src/api/notificationsApi'
import { recipientsOptions } from 'src/utils/constants'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

type IFormInput = {
  title: string
  scheduledTime: string
  repeatEvery: string
  details: string
  status: string
  recipient: number
  customRepeatDays?: number
}

const formSchema = Yup.object().shape({
  title: Yup.string().required('Yup is required'),
  scheduledTime: Yup.string().required('Scheduled Time is required'),
  repeatEvery: Yup.string().required('Select Interval is required'),
  details: Yup.string().required('Details is required'),
  status: Yup.string().required('Status is required'),
  recipient: Yup.number().required('Recipient is required'),
  customRepeatDays: Yup.number().when('repeatEvery', (repeatEvery: any) => {
    return repeatEvery?.[0] === 'custom'
      ? Yup.number().required('Custom Repeat Days is required')
      : Yup.number().notRequired()
  }),
})

type useAddNotificationProps = {
  successCallback: () => void
}
const useAddNotification = ({ successCallback }: useAddNotificationProps) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      title: '',
      scheduledTime: '',
      repeatEvery: '',
      details: '',
      recipient: 0,
      status:''
    },
  })

  const [addNotification, { isLoading: isLoadingAddNotification }] = useAddNotificationMutation()

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data)
    const formData: any = {
      timezone: dayjs.tz.guess(),
      title: data.title,
      status: data.status,
      scheduled_time: data.scheduledTime,
      content: data.details,
      target_user_types_ids: [],
      repeat_every: data.repeatEvery,
      custom_repeat_days: null,
    }

    // if repeat every field is custom
    if (data.repeatEvery === 'custom' && data.customRepeatDays) {
      formData.custom_repeat_days = data.customRepeatDays
    }

    if (data.recipient !== 0) {
      // if not selected all receipients
      formData.target_user_types_ids.push(data.recipient)
    } else {
      // if  selected all receipients
      recipientsOptions
        .filter((option) => option.value !== 0)
        .forEach((option) => {
          formData.target_user_types_ids.push(option.value)
        })
    }

    addNotification(formData)
      .unwrap()
      .then((res) => {
        successToast('Notification added successfully.')
        reset()
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to add notification.')
      })
  }

  return {
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingAddNotification,
  }
}

export default useAddNotification
